namespace GeniuzPOS.AdvPromo {
    export interface Adv05ItemDtForm {
        PmGroupId: Serenity.StringEditor;
        PmType: Serenity.LookupEditor;
        PPtype: Serenity.IntegerEditor;
        SkuCode: Serenity.StringEditor;
        PluCode: Serenity.StringEditor;
        PluShortDesc: Serenity.StringEditor;
        ItemType: Serenity.IntegerEditor;
        AssortFg: Serenity.IntegerEditor;
        StyleId: Serenity.StringEditor;
        CatCode: Serenity.StringEditor;
        SubCat1Code: Serenity.StringEditor;
        SubCat2Code: Serenity.StringEditor;
        BrandCode: Serenity.StringEditor;
        SupplCode: Serenity.StringEditor;
        Normalprice: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
        PromotionPrice: Serenity.StringEditor;
        DiscPc: Serenity.StringEditor;
    }

    export class Adv05ItemDtForm extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.Adv05ItemDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Adv05ItemDtForm.init)  {
                Adv05ItemDtForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(Adv05ItemDtForm, [
                    'PmGroupId', w0,
                    'PmType', w1,
                    'PPtype', w2,
                    'SkuCode', w0,
                    'PluCode', w0,
                    'PluShortDesc', w0,
                    'ItemType', w2,
                    'AssortFg', w2,
                    'StyleId', w0,
                    'CatCode', w0,
                    'SubCat1Code', w0,
                    'SubCat2Code', w0,
                    'BrandCode', w0,
                    'SupplCode', w0,
                    'Normalprice', w3,
                    'Remark', w0,
                    'PromotionPrice', w0,
                    'DiscPc', w0
                ]);
            }
        }
    }
}
